import { ArrowUp, ShieldCheck } from "lucide-react";
import { PROFILE } from "@/data";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-display font-extrabold tracking-tighter leading-none text-3xl sm:text-5xl lg:text-6xl text-white/10 select-none" data-testid="footer-signature">
          MD NURUL ISLAM SUMON
        </p>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <div className="flex flex-wrap items-center gap-6">
            <a
              href={PROFILE.verifyUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-verify-link"
              className="flex items-center gap-2 text-sm font-mono text-emerald-400 hover:text-emerald-300 transition-colors"
            >
              <ShieldCheck size={15} />
              {PROFILE.freelancerId} · freelancers.gov.bd
            </a>
            <a
              href={PROFILE.website}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website-link"
              className="text-sm font-mono text-[#9DAEC4] hover:text-[#D9A441] transition-colors"
            >
              imnurul.com
            </a>
          </div>
          <p className="text-sm text-[#5B6B7E]">© {new Date().getFullYear()} MD Nurul Islam Sumon. Built with craft in Bogura.</p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="btn-back-to-top"
            className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-[#C8D3E0] hover:border-[#D9A441]/60 hover:text-[#D9A441] transition-all duration-300"
          >
            <ArrowUp size={18} />
          </button>
        </div>
      </div>
    </footer>
  );
}
